<template>
    <div class="order-check">
        <div v-if="showMobileComponent" class="mo">
            <div @click="editAddress" class="order-address mb-20 flex items-center white-bg relative">
                <icon class="address-icon" icon-name="icon-dizhi" />
                <div class="address flex-1">
                    <p class="address-name bold relative">
                        <span v-if="defaultAddress">
                            {{ defaultAddress.province_name }}
                            {{ defaultAddress.city_name }}
                            {{ defaultAddress.area_name }}
                            {{ defaultAddress.detail }}
                        </span>
                        <span v-else>暂无默认地址</span>
                        <i class="absolute iconfont icon-xiangyoujiantou"></i>
                    </p>
                    <p v-if="defaultAddress" class="address-user flex items-center">
                        {{ defaultAddress.name }} <span>{{ defaultAddress.phone }}</span>
                    </p>
                </div>

                <div v-if="defaultAddress" class="edit-info pointer main-cl text-center">修改地址</div>
                <!-- <router-link to="/addaddress" v-else class="edit-info pointer main-cl text-center">去添加</router-link> -->
            </div>

            <nav class="invoice-list">
                <div
                    v-for="item in list"
                    :key="item.book_no"
                    class="invoice-item mb-20 flex items-center white-bg mb-20"
                >
                    <div class="invoice-book-info w-full">
                        <div class="invoice-book-info-top flex">
                            <div class="book-info-cover">
                                <img :src="item.image" alt="" />
                            </div>

                            <div class="book-info-text flex flex-col justify-between">
                                <p class="book-info-text-title">{{ item.name }}</p>
                                <div class="price-box no-line-height">
                                    <p class="unit price">售价: ￥{{ item.price }}元</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center justify-between">
                            <van-stepper v-model="item.count" />
                            <span class="book-info-total main-cl">￥{{ item.price * item.count }}元</span>
                        </div>
                    </div>
                </div>
            </nav>

            <div class="invoice-footer flex items-center justify-between">
                <div>
                    <p class="footer-statisc">
                        <span class="main-cl bold">￥{{ shopCarComputed.totalPrice }}元</span>
                    </p>
                    <!-- <p class="footer-statisc">
            (含运费￥{{shopCarComputed.freight}}元)
          </p> -->
                </div>

                <section class="flex items-center">
                    <div v-debounce="submitOrder" class="m-invoice-btn white text-center">提交订单</div>
                </section>
            </div>
        </div>

        <div v-else class="pc">
            <list-header class="mb-20" title="收货地址信息" icon="icon-gouwuche">
                <process :step="stepIndex" />
            </list-header>

            <div class="receipt-info flex items-center justify-between white-bg">
                <div v-if="defaultAddress" :key="defaultAddress.id">
                    <div class="receipe-item flex">
                        <div class="receipe-item-title">收货人:</div>
                        <div class="receipe-item-content bold">{{ defaultAddress.name }}</div>
                    </div>
                    <div class="receipe-item flex">
                        <div class="receipe-item-title">收货手机号:</div>
                        <div class="receipe-item-content bold">{{ defaultAddress.phone }}</div>
                    </div>
                    <div class="receipe-item flex">
                        <div class="receipe-item-title">收货地址:</div>
                        <div class="receipe-item-content bold">
                            {{ defaultAddress.province_name }}
                            {{ defaultAddress.city_name }}
                            {{ defaultAddress.area_name }}
                            {{ defaultAddress.detail }}
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="receipe-item flex">
                        <div class="receipe-item-title">未设置地址</div>
                    </div>
                </div>

                <!-- <div v-if="defaultAddress" @click="isChangeAddress = true" class="edit-info pointer main-cl text-center">编辑信息</div> -->
                <router-link to="/address/choose" v-if="defaultAddress" class="edit-info pointer main-cl text-center">
                    编辑信息
                </router-link>
                <router-link v-else to="/addaddress" class="edit-info pointer main-cl text-center">去添加</router-link>
            </div>

            <!-- 修改地址 -->
            <el-dialog append-to-body class="com-dialog" :visible.sync="isChangeAddress">
                <address-change :address="defaultAddress" @changeAddressvisible="handleChangeAddress" />
            </el-dialog>

            <list-header class="mb-20" title="商品清单" icon="icon-gouwuche" />

            <section class="shop-car-table mb-20">
                <div class="shop-car-table-header text-center flex white">
                    <p class="td-desc">刊物描述</p>
                    <p class="td-price">售价</p>
                    <p class="td-num">数量</p>
                    <p class="td-total">总价</p>
                </div>

                <nav class="shop-car-list white-bg">
                    <div v-for="item in list" :key="item.book_no" class="shop-car-item w-full flex">
                        <div class="td-desc flex items-center justify-center">
                            <div class="pic-cover">
                                <img class="cover" :src="item.image" alt="" />
                            </div>
                            <div class="shop-car-item-title flex-1">
                                {{ item.name }}
                            </div>
                        </div>
                        <!-- <div class="td-price grey-light flex items-center justify-center">￥{{item.price}}元/期</div> -->
                        <div class="td-price grey-light flex items-center justify-center">￥{{ item.price }}元</div>
                        <div class="td-num flex items-center justify-center">
                            <!-- TODO：从 /goods/type/xx 报刊列表过来的时候 立即购买不能加数量count 可能为 undefined -->
                            {{ item.count || 1 }}
                        </div>
                        <div class="td-total flex items-center justify-center bold">
                            ￥{{ item.price * (item.count || 1) }}元
                        </div>
                    </div>
                </nav>
            </section>

            <div class="order-info white-bg mb-20">
                <p class="order-info-item flex items-center justify-end">
                    <span class="order-info-item-label">支付方式:</span>
                    <span class="order-info-item-content pay-method-text main-cl">微信支付</span>
                </p>
                <!-- <p class="order-info-item flex items-center justify-end">
          <span class="order-info-item-label">应付金额:</span>
          <span class="order-info-item-content main-cl bold">￥{{totalPrice}}元</span>
        </p> -->
                <div class="order-info-item flex items-center justify-end">
                    <span class="order-info-item-label">合计:</span>
                    <p class="order-info-item-label">
                        <span class="item-price">￥{{ shopCarComputed.totalPrice }}元</span>
                        (刊物费)
                        <!-- + <span class="item-price">￥{{ shopCarComputed.freight }}元</span> -->
                        <!-- (运费) -->
                        <!-- <span class="main-cl bold text-center">￥{{(shopCarComputed.totalPrice * 1) + shopCarComputed.freight}}元</span> -->
                    </p>
                    <!-- 运费 -->
                    <!-- <span class="order-info-item-content main-cl bold">￥{{(shopCarComputed.totalPrice * 1) + shopCarComputed.freight}}元</span> -->
                    <!-- 运费 取消了 -->
                    <span class="order-info-item-content main-cl bold">￥{{ shopCarComputed.totalPrice }}元</span>
                </div>
            </div>

            <div class="flex justify-end">
                <div v-debounce="submitOrder">
                    <com-button class="confirm-order" label="确认订单"></com-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Process from "@/components/pc/Process";
    import ListHeader from "@/components/pc/ListHeader";
    import { queryDefaultAddress } from "@/apis/address";
    // import { createOrder } from "@/apis/order";
    import $order from "@/mixins/order";
    import addressChange from "@/components/pc/addressChange";

    export default {
        components: {
            ListHeader,
            Process,
            addressChange,
        },
        mixins: [$order],
        data: () => ({
            value: 1,
            // 进度
            stepIndex: 1,
            // 是否全選
            allSelected: false,
            // 订单报刊列表
            list: [],
            // 默认地址信息
            defaultAddress: null,
            // 是否是购物车的订单
            isCart: false,
            // 是否显示修改地址弹窗
            isChangeAddress: false,
        }),
        created() {
            this.isCart = !!this.$route.params.id;
            this.list = localStorage["orderList"] ? JSON.parse(localStorage["orderList"]) : [];
            // 获取默认地址
            if (localStorage["checkAddress"]) {
                this.defaultAddress = JSON.parse(localStorage["checkAddress"]);
                // console.log(JSON.parse(localStorage['checkAddress']));
                return;
            }
            queryDefaultAddress().then(({ result }) => {
                this.defaultAddress = result;
            });
        },
        computed: {
            // 结算统计
            shopCarComputed() {
                let totalNum = 0;
                let totalPrice = 0;
                let selectArr = [];
                this.list.forEach((item) => {
                    const count = item.count || 1;
                    totalNum += count;
                    totalPrice += item.price * count;
                    selectArr.push(item);
                });
                return {
                    totalNum,
                    totalPrice: totalPrice.toFixed(2),
                    selectArr,
                    freight: totalNum < 5 && totalNum ? Math.floor(totalPrice * 0.2) : 0,
                };
            },
        },
        methods: {
            // 编辑地址
            editAddress() {
                const { $router } = this;
                // if(defaultAddress){
                //   localStorage['editAddress'] = JSON.stringify(defaultAddress);
                //   return
                // }
                // $router.push('/address/form' + (defaultAddress ? '/1': ''));
                $router.push("/address/choose");
            },
            handleChangeAddress(flag) {
                this.isChangeAddress = flag;
                // 获取默认地址
                queryDefaultAddress().then(({ result }) => {
                    this.defaultAddress = result;
                });
            },
            // 提交訂單
            submitOrder() {
                const { list, defaultAddress, isCart, $useMessage } = this;
                const books = list.map((item) => ({
                    book_no: item.book_no,
                    count: item.count,
                }));

                if (!defaultAddress) return $useMessage({ type: "error", message: "请去添加默认地址" });

                const orderInfo = {
                    books,
                    address_id: defaultAddress.id,
                    trade_type: this.runEnv,
                    is_cart: isCart,
                };
                this.toCreateOrder(orderInfo);
            },
        },
        destroyed() {
            localStorage.removeItem("checkAddress");
        },
    };
</script>

<style lang="less" scoped>
    .order-check {
        padding-bottom: 1.4rem;
    }
    .receipt-info {
        border-radius: 0.16rem;
        padding: 0.42rem;
        font-size: 0.18rem;
        margin-bottom: 0.7rem;
    }

    .receipe-item {
        color: #666;
        margin-bottom: 0.1rem;
        &:last-of-type {
            margin-bottom: 0;
        }
        &-title {
            margin-right: 0.06rem;
            color: #999;
            width: 1.2rem;
            text-align: right;
        }
    }
    .edit-info {
        font-size: 14px;
        border: 1px solid #d8271c;
        border-radius: 0.2rem;
        height: 0.4rem;
        width: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0.4rem;
    }

    .order-info {
        border-radius: 0.16rem;
        padding: 0.34rem 0.24rem;

        &-item {
            margin-bottom: 0.16rem;

            &-label {
                color: #666;
                text-align: right;
            }

            &-content {
                width: 2.2rem;
                text-align: right;
                font-size: 0.28rem;
                &.pay-method-text {
                    font-size: 0.2rem;
                }
            }
        }
        &-note {
            font-size: 0.14rem;
            color: #777;

            .user-info {
                margin-left: 0.4rem;
            }
        }
    }

    .confirm-order {
        width: 200px;
        height: 0.6rem;
        font-size: 0.24rem;
    }

    .shop-car {
        padding-bottom: 1.4rem;
    }

    .shop-car-table {
        border-radius: 0.16rem;
        overflow: hidden;

        &-header {
            padding: 0 0.2rem;
            height: 0.6rem;
            line-height: 0.6rem;
            font-size: 0.18rem;
            .td-desc {
                text-align: left;
                padding-left: 20% !important;
            }
            background: #d8271c;
        }
        .td-desc {
            width: 46%;
            flex: 1;
            padding: 0 0.1rem;
        }
        .td-price {
            width: 12%;
            padding: 0 0.1rem;
        }
        .td-num {
            width: 16%;
            padding: 0 0.1rem;
        }
        .td-total {
            width: 16%;
            padding: 0 0.1rem;
        }
        .td-operate {
            width: 10%;
            padding: 0 0.1rem;
        }

        .shop-car-item {
            padding: 0.45rem 0;
            border-bottom: 1px solid #ccc;
            font-size: 0.18rem;

            &:last-child {
                border-bottom: none;
            }

            &-title {
                font-size: 0.18rem;
                color: #333;
                padding-left: 0.5rem;
            }
            .td-desc {
                padding-left: 0.2rem;
            }
            .td-total {
                font-size: 0.2rem;
            }
            .td-operate {
                padding-right: 0.2rem;
            }
            .operate-btn {
                width: 100%;
                border: 1px solid #e1e1e1;
                height: 0.4rem;
                border-radius: 0.4rem;
                line-height: 0.4rem;
                font-size: 0.14rem;
                color: #666;
                transition: 0.3s all;

                &:hover {
                    color: #fff;
                    background: #d8271c;
                    border: 0;
                }
            }
        }

        .pic-cover {
            height: 1.52rem;
            width: 1.78rem;
            .cover {
                height: 100%;
                width: auto;
                display: block;
                margin: 0 auto;
            }
        }
    }
    /deep/.van-stepper__minus,
    /deep/.van-stepper__plus {
        background: #d8271c;
        color: #fff;
    }
    /deep/.van-stepper__minus--disabled,
    .van-stepper__plus--disabled {
        color: #999;
        background: #d9d9d9;
    }
    /deep/.van-checkbox__icon--checked .van-icon {
        background: #d8271c;
        border-color: #d8271c;
    }
    .shop-car-list {
        margin-bottom: 0.4rem;
        padding-right: 0.2rem;
    }
    .settlement {
        border-radius: 0.16rem;
        height: 0.8rem;
        overflow: hidden;
        padding-left: 0.2rem;
        color: #333;

        .select-all {
            font-size: 0.2rem;
            color: #333;
            margin-left: 0.04rem;
        }

        .select-number {
            font-size: 0.18rem;
            margin-left: 0.36rem;

            .main-cl {
                font-size: 0.2rem;
            }
        }

        .settlement-price {
            color: #777;
            font-size: 0.16rem;
            .item-price {
                color: #333;
                font-size: 0.2rem;
                padding: 0 0.16rem;
            }
            .main-cl {
                display: block;
                font-size: 0.24rem;
                min-width: 1.9rem;
                padding: 0 0.1rem;
            }
            .settlement-btn {
                font-size: 0.24rem;
                line-height: 0.8rem;
                background: #d8271c;
                letter-spacing: 3px;
                width: 1.54rem;
            }
        }
    }
    @media (max-width: 767px) {
        .order-check {
            background: #f5f5f5;
            min-height: calc(100vh - 50px);
        }
        .edit-info {
            position: absolute;
            width: 1.2rem;
            height: 0.46rem;
            bottom: 0.3rem;
            right: 0.3rem;
            background: #f1f1f1;
            border-radius: 0.04rem;
            border: 0;
        }
    }
    // mo
    .order-address {
        border-radius: 0 0 0.16rem 0.16rem;
        padding: 0.62rem 0.3rem;
        .address-icon {
            width: 0.6rem;
            height: 0.6rem;
            margin-right: 0.3rem;
        }
        .edit-btn {
            right: 0.3rem;
            bottom: 0.32rem;
            background: #f1f1f1;
            border-radius: 0.04rem;
            padding: 0.1rem;
        }
        .address {
            font-size: 0.26rem;
            &-name {
                font-size: 0.36rem;
                color: #333;
                padding-right: 1.2rem;
                .iconfont {
                    right: 0;
                    top: 50%;
                    color: #999;
                    font-size: 0.26rem;
                    transform: translateY(-50%);
                }
            }
            &-user {
                color: #666;
                margin-top: 0.16rem;
                span {
                    color: #999;
                }
            }
        }
    }
    .invoice-list {
        padding: 0 0.3rem 1.2rem;
        .invoice-item {
            padding: 0.36rem 0.18rem;
            box-shadow: 0 0.08rem 0.16rem 0 rgba(47, 8, 8, 0.12);
            border-radius: 0.14rem;
        }
    }
    .invoice-book-info {
        padding-left: 0.2rem;
        &-top {
            .book-info-cover {
                width: 1.58rem;
                height: 2.27rem;
                overflow: hidden;
                img {
                    max-height: 100%;
                    object-fit: cover;
                }
            }
            .book-info-text {
                font-size: 0.28rem;
                color: #666;
                padding: 0.06rem 0 0.16rem 0.3rem;

                &-title {
                    color: #222;
                    font-size: 0.36rem;
                }
                .price-box .unit {
                    margin-bottom: 0.2rem;
                }
            }
        }

        .book-info-total {
            font-size: 0.36rem;
        }
        // /deep/.van-stepper__minus, /deep/.van-stepper__plus{
        //   width: .5rem;
        //   height: .36rem;
        // }
        // /deep/.van-stepper__input{ height: .36rem; margin: 0; width: .6rem; }
    }
    .invoice-footer {
        height: 1rem;
        width: 100vw;
        padding: 0 0.3rem;
        position: fixed;
        // bottom: 50px;
        bottom: 0;
        left: 0;
        background: #fff;
        background: #ffffff;
        box-shadow: 0px -3px 5px 0px rgba(47, 8, 8, 0.1);
        border-radius: 0.14rem 0.14rem 0 0;
        border-bottom: 1px solid rgba(204, 204, 204, 0.7);

        .select-all /deep/.van-checkbox__label {
            font-size: 0.3rem;
            color: #666;
        }
        .footer-statisc {
            font-size: 0.3rem;
            line-height: 1;
            color: #999;
            .main-cl {
                font-size: 0.36rem;
            }
        }
        .m-invoice-btn {
            font-size: 0.3rem;
            width: 2rem;
            margin-left: 0.3rem;
            height: 0.6rem;
            background: #d8271c;
            line-height: 0.6rem;
            border-radius: 0.6rem;
        }
    }
</style>
